const EXPERIENCE_SOURCE_RUBRIC_COOKIE_PREFIX = 'exp_source_rubric_';
const EXPERIENCE_SOURCE_RUBRIC_MAX_AGE_SECONDS = 10 * 60;

const getExperienceSourceRubricCookieName = (experienceId: number | string) => {
  return `${EXPERIENCE_SOURCE_RUBRIC_COOKIE_PREFIX}${encodeURIComponent(String(experienceId))}`;
};

const getCookieAttributes = (maxAge: number) => {
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';

  return `Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`;
};

export const setExperienceSourceRubricCookie = (experienceId: number | string, rubricSlug?: string | null) => {
  if (typeof document === 'undefined') {
    return;
  }

  const cookieName = getExperienceSourceRubricCookieName(experienceId);

  if (!rubricSlug || rubricSlug === 'all') {
    document.cookie = `${cookieName}=; ${getCookieAttributes(0)}`;

    return;
  }

  document.cookie = `${cookieName}=${encodeURIComponent(rubricSlug)}; ${getCookieAttributes(
    EXPERIENCE_SOURCE_RUBRIC_MAX_AGE_SECONDS,
  )}`;
};
